import { render } from "./teaXbEchart.vue?vue&type=template&id=0db69ec0&scoped=true"
import script from "./teaXbEchart.vue?vue&type=script&lang=js"
export * from "./teaXbEchart.vue?vue&type=script&lang=js"

import "./teaXbEchart.vue?vue&type=style&index=0&id=0db69ec0&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db69ec0"]])

export default __exports__